import { captureException } from '@sentry/browser';
import HttpService from '../common/http/HttpService';
import EventLoggingEndpoint from './const/EventLoggingEndpoint';

function logFrontendEvent(event) {
  try {
    HttpService.post(EventLoggingEndpoint.LOG_FRONTEND_EVENT, { event });
  } catch (error) {
    captureException(error);
  }
}

function logUserSpecificFrontendEvent(event) {
  try {
    HttpService.post(EventLoggingEndpoint.LOG_USER_SPECIFIC_FRONTEND_EVENT, { event });
  } catch (error) {
    captureException(error);
  }
}

const EventLoggingService = {
  logFrontendEvent,
  logUserSpecificFrontendEvent,
};

export default EventLoggingService;
